export default {
    rawMaterials: [],
    totalDataRow:0 
}
  